module.exports = __webpack_public_path__ + "static/img/blue bgi.a9c4b92a.jpg";